import qs from 'query-string';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useQueryString = <
  T extends Record<string, any> = Record<string, string | undefined>,
>() => {
  const location = useLocation();

  const parsed = useMemo(() => qs.parse(location.search) as Partial<T>, [location.search]);

  return parsed;
};
